import React from 'react';
import _ from 'lodash';
import { Form } from 'semantic-ui-react';
import { useDispatch } from 'react-redux';
import { ATTRIBUTE_TYPE, ATTRIBUTE_TYPE_INPUT_TYPE_MAPPING } from '../../../../HelperMethods/FormUtils';
import { PICKLIST_OPTIONS } from './lib/constants';
import { CONTAINERS, resetView } from '../../../common/cardNavigationComponent/cardNavigationRedux';
import LocationCard from '../../../common/locationCard/LocationCard';
import IButtonComponent from '../../../common/IButtonComponent';

export default function LocationTaskFieldComponent({ task, attributeObj, formik, disabled, ...props }) {
  const locationValue = _.get(formik.values, attributeObj.attributeName);
  const attributeOptions =
    attributeObj.attributeName === 's_stop'
      ? _.get(props, PICKLIST_OPTIONS.STOP, { isLoading: false, items: [] })
      : _.get(props, PICKLIST_OPTIONS.ASSET, { isLoading: false, items: [] });
  const attributeOnChange = (event, data) => {
    formik.setFieldValue(attributeObj.attributeName, data.value);
    const onChangeFunction =
      attributeObj.attributeName === 's_stop'
        ? _.get(props.onValueChange, 'onStopChange')
        : _.get(props.onValueChange, 'onAssetChange');
    onChangeFunction({ name: attributeObj.attributeName, value: data.value, attributeObj, formik });
    formik.setFieldTouched(attributeObj.attributeName, true, false);
  };
  const dispatch = useDispatch();

  const onIButtonClicked = () => {
    dispatch(
      resetView(CONTAINERS.TASK_VIEW, {
        component: LocationCard,
        props: {
          locationId: locationValue,
        },
      })
    );
  };
  const attributeOnSearch = (event) => {
    if (attributeObj.attributeName === 's_stop') {
      _.get(props, 'onSearchStop')?.call(null, { event, formik });
    } else {
      _.get(props, 'onSearchAsset')?.call(null, { event, formik });
    }
  };

  const mappingParams = () => {
    const param = {
      name: attributeObj.attributeName,
      value: locationValue,
      options: attributeOptions,
      placeholder: attributeObj.displayName || attributeObj.name,
      onChange: attributeOnChange,
      multiple: attributeObj.multiple,
      disabled,
    };
    if (!(attributeObj.attributeName === 's_asset' && _.get(formik.values, 's_stop'))) {
      param.onSearchChange = attributeOnSearch;
    }
    return param;
  };

  return (
    <Form.Field>
      <>
        <label>
          {attributeObj.displayName}
          {attributeObj.isMandatory ? <span className="mandatory-field">*</span> : null}
        </label>
        <IButtonComponent style={{ float: 'right' }} onClick={onIButtonClicked} disabled={!locationValue} />
        {ATTRIBUTE_TYPE_INPUT_TYPE_MAPPING[ATTRIBUTE_TYPE.PICKLIST](mappingParams())}
      </>
    </Form.Field>
  );
}
